var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#bba8fa;}.a{opacity:0.15;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.638,9.635A5.654,5.654,0,1,0,4.98,11.247v1.89H3.651a.664.664,0,1,0,0,1.328H4.98v1.871a.664.664,0,0,0,1.329,0V14.465H7.638a.664.664,0,1,0,0-1.328H6.309v-1.89A5.621,5.621,0,0,0,9.638,9.635ZM2.591,8.7A4.318,4.318,0,1,1,8.7,8.7,4.321,4.321,0,0,1,2.591,8.7Z",
    transform: "translate(6.355 3.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.97c16494d5be8e45399536bab72403b4.svg";
export { ForwardRef as ReactComponent };